<template>
  <div class="currency-cell-renderer">
    <span>{{ formattedValue }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const {
  value,
  //
  currency,
} = props.params

const currencyDictionary = {
  USD: 'en-US',
}

const formattedValue = computed(() => {
  if (!value || Number.isNaN(value)) return ''

  const absValue = Math.abs(value)

  return new Intl.NumberFormat(
    currency ? currencyDictionary[currency] : 'en-US',
    {
      style: 'currency',
      currency: currency ?? 'USD',
    }).format(absValue)
})
</script>
